import { apiFetch, jsonOpts, parseJson } from "./client";
import type { VisitDossier } from "./types";

export async function getDossier(visitId: string): Promise<VisitDossier> {
  return parseJson<VisitDossier>(
    await apiFetch(`/api/visits/${visitId}/dossier`)
  );
}

export async function updateGoal(
  visitId: string,
  goal: string
): Promise<VisitDossier> {
  return parseJson<VisitDossier>(
    await apiFetch(`/api/visits/${visitId}/dossier`, {
      ...jsonOpts,
      method: "PATCH",
      body: JSON.stringify({ goal }),
    })
  );
}
